<div class="home-search">
    <form class="search-form-well">
      <mat-form-field  class="search-well dense-3">
        <mat-label class = "label-well-or-field">Buscá un pozo o yacimiento</mat-label>
        <input type="text"  aria-label="Well" matInput #searchText (keyup.enter)="goToWellSearch(searchText.value)">
        <span matIconSuffix class="cursor-pointer" (click)="goToWellSearch(searchText.value)">
          <mat-icon class="material-icons-outlined" aria-hidden="false" aria-label="Account">search</mat-icon>
        </span>
      </mat-form-field>    
    </form>
  </div>